export const SWITCH_SIDE_BAR_MENU = 'SWITCH_SIDE_BAR_MENU'
export const SET_ACTIVE_MENU_ITEM = 'SET_ACTIVE_MENU_ITEM'
export const SWITCH_FILTER_MENU = 'SWITCH_FILTER_MENU'
